import { Reveal } from "@/components/Reveal";

const Founder = ({ compact = false }) => (
  <section
    className={compact ? "pb-20 sm:pb-24" : "py-20 sm:py-28 lg:py-36 border-t border-white/10"}
    data-testid={compact ? "founder-section-compact" : "founder-section"}
    id={compact ? undefined : "about"}
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className={`grid lg:grid-cols-12 items-center ${compact ? "gap-8 lg:gap-12" : "gap-10 lg:gap-16"}`}>
        <Reveal className={compact ? "lg:col-span-4" : "lg:col-span-5"}>
          <div
            className={`rounded-2xl overflow-hidden border border-white/10 bg-surface ${
              compact
                ? "max-w-[200px] sm:max-w-[260px] lg:max-w-[280px]"
                : "max-w-[240px] sm:max-w-[320px] lg:max-w-[420px]"
            }`}
            data-testid="founder-portrait"
          >
            <img
              src="/bo-vinding.jpg"
              alt="Bo Vinding, Founder and Managing Member of Vibera Group LLC"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
        </Reveal>
        <div className={compact ? "lg:col-span-8" : "lg:col-span-7"}>
          <Reveal>
            <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-flame">Founder</p>
            <h2
              className={`mt-4 font-syne font-bold tracking-tight text-white ${
                compact ? "text-2xl sm:text-3xl" : "text-3xl sm:text-4xl lg:text-5xl"
              }`}
            >
              Built from a business owner's perspective.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p
              className={`font-syne font-bold text-white ${compact ? "mt-5 text-lg" : "mt-8 text-xl"}`}
              data-testid={compact ? "founder-name-compact" : "founder-name"}
            >
              Bo Vinding
            </p>
            <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-gray-500">
              Founder &amp; Managing Member — Vibera Group LLC
            </p>
            <div
              className={`space-y-4 text-gray-400 leading-relaxed ${
                compact ? "mt-5 text-sm max-w-2xl" : "mt-6 text-base max-w-2xl"
              }`}
            >
              <p>Bo Vinding is the founder and managing member of Vibera Group LLC.</p>
              <p>
                An entrepreneur with extensive experience building and operating eCommerce and consumer
                businesses, Bo founded Vibera to bring a commercially focused approach to digital marketing.
              </p>
              <p>
                His background as a business owner shapes Vibera's approach: marketing should not be
                measured by activity alone, but by its contribution to sustainable and profitable growth.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Founder;
